import api from './http';

// Partners
export const getPartners = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/partners${queryString ? `?${queryString}` : ''}`);
};
export const getPartner = (id) => api.get(`/partners/${id}`);
export const createPartner = (data) => api.post('/partners', data);
export const updatePartner = (id, data) => api.patch(`/partners/${id}`, data);
export const deletePartner = (id) => api.delete(`/partners/${id}`);

// Custom tags (types creables a la volee)
export const getCustomTags = (category) => api.get('/custom-tags', { params: { category } });
export const createCustomTag = (category, label) => api.post('/custom-tags', { category, label });
